import script from "./SenderReceiversBlock.vue?vue&type=script&lang=ts&setup=true"
export * from "./SenderReceiversBlock.vue?vue&type=script&lang=ts&setup=true"

import "./SenderReceiversBlock.vue?vue&type=style&index=0&id=3713085f&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3713085f"]])

export default __exports__